import React from 'react'

const About = () => {
  return (
    <div>소개페이지</div>
  )
}

export default About